<div class="end-step-marker">
  {{ 'COMMON.ACTION_LABELS.END' | translate }}
</div>
